import api from './api';

const SEPARATOR = '|||';

function buildPrompt(userPrompt, count, language, textType) {
  let prompt = `Ich spiele World of Warcraft und brauche für mein Rollenspiel genau ${count} Texte in der Sprache ${language}. Jeder Text darf maximal 240 Zeichen lang sein. Trenne jeden Text mit dem Trenner ${SEPARATOR} voneinander. Gib NUR die ${count} Texte zurück, getrennt durch ${SEPARATOR}, keine Erklärungen, keine Nummerierungen, kein zusätzlicher Text.`;

  if (textType === 'emote') {
    prompt += ` Diese Texte sind Emotes. Das Spiel stellt den Charakternamen automatisch voran. Schreibe KEINEN Namen. Beginne jeden Satz mit einem kleingeschriebenen Verb in der dritten Person. Kein %t verwenden. Beispiel: zwinkert schelmisch.${SEPARATOR}kichert leise.`;
  } else {
    prompt += ` Wenn in den Texten ein anderer Spieler angesprochen werden soll, verwende den Platzhalter %t. Das Spiel ersetzt %t durch den Namen des Ziels. Beispiel: Hallo %t, schön dich zu sehen!${SEPARATOR}%t, willst du einer Gruppe beitreten?`;
  }

  if (userPrompt && userPrompt.trim()) {
    prompt += `\n\nRahmenparameter:\n${userPrompt.trim()}`;
  }

  return prompt;
}

export async function generateTexts(userPrompt, count, language, textType) {
  const prompt = buildPrompt(userPrompt, count, language, textType);
  const text = await api.generateText(prompt);

  const messages = text
    .split(SEPARATOR)
    .map(line => line.trim())
    .filter(line => line.length > 0)
    .map(line => line.replace(/^\d+[\.\)]\s*/, '').replace(/^[-•]\s*/, ''))
    .filter(line => line.length > 0)
    .slice(0, count);

  return messages;
}
